import { privateConstant } from './contant';

export function isPrivilegedUser(userInfo) {
  if (!userInfo) {
    return false;
  }

  if (userInfo?.is_super_admin) {
    return true;
  }

  const rolesByProject = userInfo?.roles_by_project || {};
  const roleGroups = Object.values(rolesByProject);

  return roleGroups.some((roles) => {
    return (
      Array.isArray(roles) && roles.some((role) => String(role).toLowerCase().includes('admin'))
    );
  });
}

const isNavigablePath = (path) => Boolean(path) && !String(path).includes(':');

const canAccessRoute = ({ accessName, accessPermissions, isPrivileged }) => {
  if (isPrivileged || !accessName) {
    return true;
  }

  return Boolean(accessPermissions?.[accessName]);
};

export const canAccessPrivatePath = (path, accessPermissions, userInfo) => {
  if (!path) {
    return false;
  }

  const isPrivileged = isPrivilegedUser(userInfo);
  const matchedRoute = privateConstant.find((route) => {
    if (route.path === path) {
      return true;
    }

    return Boolean(route.child?.some((child) => child.path === path));
  });

  if (!matchedRoute) {
    return false;
  }

  if (matchedRoute.path === path) {
    return canAccessRoute({
      accessName: matchedRoute.accessName,
      accessPermissions,
      isPrivileged,
    });
  }

  const matchedChild = matchedRoute.child?.find((child) => child.path === path);

  return canAccessRoute({
    accessName: matchedChild?.accessName || matchedRoute.accessName,
    accessPermissions,
    isPrivileged,
  });
};

export const resolveDefaultPrivatePath = (accessPermissions, userInfo, fallbackPath = null) => {
  const isPrivileged = isPrivilegedUser(userInfo);
  const candidatePaths = privateConstant.flatMap((route) => {
    if (route.hidden) {
      return [];
    }

    const childPaths =
      route.child?.filter(
        (child) =>
          !child.hidden &&
          isNavigablePath(child.path) &&
          canAccessRoute({
            accessName: child.accessName || route.accessName,
            accessPermissions,
            isPrivileged,
          }),
      ) || [];

    const hasParentPathAccess =
      isNavigablePath(route.path) &&
      canAccessRoute({
        accessName: route.accessName,
        accessPermissions,
        isPrivileged,
      });
    const parentPath = hasParentPathAccess ? [{ path: route.path }] : [];

    return [...childPaths, ...parentPath];
  });

  return candidatePaths[0]?.path || fallbackPath;
};
